<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">
      <div style="padding:20px 30px">
        <h2>线上展会</h2>
        <p>线上展会内容将在此处显示</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Xszh',
  data () {
    return {
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.pageNum = key
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.gyzgcont {
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  margin-top: -20px;
  position: relative;
  z-index: 10;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/xszh.vue